<template>
  <div v-if="loading">
    <loader></loader>
  </div>
  <div v-else>
    <h1>Requisições</h1>
    <hr>
    <div class="row">
      <div>
          <div class="row">
            <div class="col-sm-2">
              <select class="input-sm" v-model="perPage" @change="getList">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="15">15</option>
              </select>
            </div>
            <div class="col-sm-5"></div>
            <div class="col-sm-5">
              <b-form-input v-model="filter" @keyup.enter="getList" placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
            </div>
          </div>
          <b-table :items="requests" :fields="requestsfields" striped hover>
            <span slot="icon" slot-scope="item">
                <span class="glyphicon glyphicon-file"> </span>
            </span>
            <span slot="reqType" slot-scope="item">
              <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <span slot="name" slot-scope="item">
                <!-- Caso não possua ADMIN_WORKFLOWS -->
                <span v-if="item.item.workflow">{{item.item.workflow.get('name')}}</span>
                
            </span>
            <template slot="currentStep" slot-scope="item">
                <span v-if="item.value">{{item.value.get('name')}}</span>
            </template>
            <request-status slot="status" slot-scope="item" :status="item.value">
            </request-status>
            <span slot="owner" slot-scope="item">
              <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <router-link slot="options" slot-scope="item"
                             :to="{name: 'RequestDetail', params: {id: item.item.objectId}}"
                             class="btn btn-primary btn-xs">
              <span class="glyphicon glyphicon-search"></span> Ver
            </router-link>
          </b-table>
          <b-pagination size="sm" :total-rows="count" :per-page="perPage" v-model="currentPage" @input="getList" />
      </div>
    </div>
  </div>
</template>

<script>

import Loader from './util/Loader'
import { Parse } from '../Global'
import RequestStatus from './util/RequestStatus'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader,
    RequestStatus
  },
  data () {
    return {
      loading: false,
      requests: [],
      count: 0,
      requestsfields: {
        icon: { label: '' },
        objectId: { label: 'Identificador', sortable: true },
        reqType: { label: 'Tipo', sortable: true },
        name: { label: 'Workflow', sortable: true },
        currentStep: { label: 'Passo', sortable: true },
        status: { label: 'Status', sortable: true },
        owner: { label: 'Criador', sortable: true },
        createdAtFmt: {label: 'Data de Abertura', sortable: true},
        options: {label: 'Opções'}
      },
      currentPage: 1,
      perPage: 5,
      filter: null
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      let self = this
      self.loading = true
      let params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter
      }
      Parse.Cloud.run('listRequests', params).then((results) => {
        self.requests = results.requests
        self.count = results.count
        self.loading = false
      }).fail(error => {
        handleParseError(self, error)
        self.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// RequestList.vue?caa3588c